import React, { useEffect, useState } from 'react';
import Model from '../../../model';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import Loader from 'components/Loader';

const LoginRedirect = () => {
    const [ searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [ renderBody, setRenderBody ] = useState(
        <Loader styles={{height: '100%'}}/>
    );

    useEffect(() => {
        const loginFormParams = {};
        if (searchParams.has('next')) {
            loginFormParams['redirect'] = searchParams.get('next');
        }
        if (loginFormParams['redirect'] && Model.user.isAuthenticated) {
            navigate(loginFormParams['redirect'], { replace: true });
        }
        loginFormParams['initial'] = 'login';
        setRenderBody(<Navigate to={'/'} replace={true} state={{login: loginFormParams}}/>)
    }, [searchParams]);

    return renderBody;
}

export default LoginRedirect;
